<h1 mat-dialog-title>Facturas manuales</h1>
<div mat-dialog-content>
  <form *ngIf="!loading" [formGroup]="form" (ngSubmit)="search()">
    <mat-form-field class="margin-right-small">
      <input
        type="number"
        matInput
        placeholder="Número de factura"
        formControlName="invoiceNumber"
      />
    </mat-form-field>

    <mat-form-field class="medium-width">
      <input
        type="text"
        #client
        matInput
        placeholder="Cliente"
        formControlName="client"
        [matAutocomplete]="autClient"
      />
      <mat-autocomplete
        #autClient="matAutocomplete"
        [displayWith]="filterCompleteClients.displayFn"
      >
        <mat-option
          *ngFor="let client of filteredClientsOptions | async"
          [value]="client"
        >
          {{ client.Name }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
    <button mat-button type="submit">Buscar</button>
  </form>



  <div style="max-height: 200px; overflow-y: scroll; " class="card-content margin-botton-medium">

        <table class="search-table search-table-fixed" mat-table [dataSource]="dataSource">

            <ng-container matColumnDef="invoiceNumber">
                <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                    <resizable-column-control width="60" tile="Número" #resColConfidential></resizable-column-control>
                </th>
                <td class="search-table-cell" mat-cell *matCellDef="let element">
                    <div><b>{{ element.InvoiceNumberComplete }}</b></div>
                </td>
            </ng-container>

            <ng-container matColumnDef="invoiceDate">
                <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                    <resizable-column-control width="100" tile="Fecha" #resColDateTime></resizable-column-control>
                </th>
                <td class="search-table-cell" mat-cell *matCellDef="let element">
                    <div>{{element.InvoiceDate | date:"dd/MM/yyyy" }}</div>
                </td>
            </ng-container>

            <ng-container matColumnDef="amount">
                <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                    <resizable-column-control width="100" tile="Importe" #resColDateTime></resizable-column-control>
                </th>
                <td class="search-table-cell" mat-cell *matCellDef="let element">
                    <div>{{ element.Amount }}</div>
                </td>
            </ng-container>

            <ng-container matColumnDef="alicuotsColumn">
                <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                    <resizable-column-control width="100" tile="Iva" #resColDateTime></resizable-column-control>
                </th>
                <td class="search-table-cell" mat-cell *matCellDef="let element">
                    <div>{{ element.AlicuotsColumn }}</div>
                </td>
            </ng-container>



            <tr mat-header-row class="search-table-header" *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr (click)="asociate(row)" mat-row class="search-table-cell" *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

</div>

</div>
<div class="clearfix">
  <div class="pull-right">
    <button mat-button type="button" cdkFocusInitial (click)="cancel()">
      Cancelar
    </button>
  </div>
</div>
